import React, { memo } from "react";

import MaterialRadio from "@mui/material/Radio";
import { styled } from "@mui/material";

// Interfaces
import { IRadioAllowedProps } from "~/types/vendor";

const defaultStyling = {
  color: "grey.100",
  background: "transparent",
  "& ~ &": {
    background: "transparent",
  },
  "&:hover": {
    background: "transparent",
  },
};

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 20,
  height: 20,
  boxShadow: "none",
  border: `2px solid ${theme.palette.action.disabledBackground}`,
  padding: 2,
  "input:disabled ~ &": {
    boxShadow: "none",
  },
}));

const BpCheckedIcon = styled(BpIcon)(({ theme }) => ({
  backgroundColor: "transparent",
  borderColor: `${theme.palette.primary.main}`,
  "&:before": {
    display: "block",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    backgroundColor: "#1874fd",
    content: '""',
  },
}));

const Radio: React.FC<IRadioAllowedProps> = memo(
  ({ icon, checkedIcon, sx, ...props }) => {
    return (
      <MaterialRadio
        icon={icon ? icon : <BpIcon />}
        checkedIcon={checkedIcon ? checkedIcon : <BpCheckedIcon />}
        sx={{
          ...defaultStyling,
          ...sx,
          marginRight: "9px",
        }}
        {...props}
      />
    );
  }
);

Radio.displayName = "Radio";

export default Radio;
